import { useCallback, useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link2, Trash2, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/pages/admin/AdminLayout";
import { WhatsAppInbox } from "@/components/WhatsAppInbox";

const day = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "mai");

function Devices() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [link, setLink] = useState(null);
  const load = useCallback(() => api.get("/admin/inbox/devices").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try {
      setLink((await api.post("/admin/inbox/devices", { name })).data.url);
      setName("");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const revoke = async (d) => {
    if (!window.confirm(`Scollegare "${d.name}"? Il link smetterà di funzionare.`)) return;
    await api.delete(`/admin/inbox/devices/${d.id}`);
    load();
  };
  return (
    <div className="mb-6 rounded-2xl border bg-white p-4" data-testid="wa-devices">
      <p className="font-display font-semibold">Dispositivi collegati</p>
      <p className="mb-3 text-xs text-slate-500">Crea un link per usare questa casella da un altro telefono, tablet o PC, anche in contemporanea. Chi ha il link può leggere e rispondere: puoi scollegarlo quando vuoi.</p>
      <div className="flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome dispositivo (es. PC ufficio)" data-testid="wa-device-name" />
        <Button onClick={add} disabled={name.trim().length < 2} className="shrink-0 rounded-full" data-testid="wa-device-add"><Link2 className="h-4 w-4" /> Crea link</Button>
      </div>
      <div className="mt-3 divide-y text-sm">
        {list.map((d, i) => (
          <div key={d.id} className="flex items-center justify-between py-2" data-testid={`wa-device-${i}`}>
            <span>{d.name} <span className="text-xs text-slate-400">· ultimo accesso {day(d.last_seen)}</span></span>
            <Button size="sm" variant="ghost" className="text-red-600" onClick={() => revoke(d)} data-testid={`wa-device-revoke-${i}`}><Trash2 className="h-4 w-4" /> Scollega</Button>
          </div>
        ))}
      </div>
      <Dialog open={!!link} onOpenChange={(v) => !v && setLink(null)}>
        <DialogContent className="max-w-sm text-center" data-testid="wa-device-link-dialog">
          <DialogHeader><DialogTitle>Link di collegamento</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Inquadra il QR con l'altro dispositivo oppure copia il link. Viene mostrato solo ora.</p>
          {link && <div className="mx-auto rounded-xl border p-3"><QRCodeSVG value={link} size={200} /></div>}
          <p className="break-all rounded-lg bg-slate-50 p-2 text-xs" data-testid="wa-device-link">{link}</p>
          <Button onClick={() => { navigator.clipboard.writeText(link); toast.success("Link copiato"); }} className="rounded-full" data-testid="wa-device-copy"><Copy className="h-4 w-4" /> Copia link</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default function AdminWhatsApp() {
  return (
    <div>
      <PageHeader eyebrow="Numero aziendale +39 081 892 9750" title="WhatsApp" />
      <Devices />
      <WhatsAppInbox />
    </div>
  );
}
